import { Grid, makeStyles, Typography } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";

const useStyles = makeStyles((theme) => ({
  eventTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  boldText: {
    fontWeight: 600,
    display: "inline",
  },
}));

export const MaintenanceRequested = ({ building, onClose }) => {
  const classes = useStyles();

  return (
    <Box>
      <Header
        title="Maintenance Requested"
        building={building}
        onClose={onClose}
      />

      <InfoBox color="#FFE6E6">
        <Typography variant="h4">Upcoming elevator checkup</Typography>
      </InfoBox>

      <Typography className={classes.eventTitle}>
        Elevator routine maintenance
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography className={classes.boldText}>Last inspection:</Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.boldText}>Nov 30, 2021</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography className={classes.boldText}>Next inspection:</Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.boldText}>
            Feb 28, 2022 -{" "}
            <Typography className={classes.boldText} color="primary">
              in 5 days
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <GroupButton
        buttons={[
          { text: "SHARE" },
          { text: "VIEW REPORT" },
          { text: "EXPORT SAME TYPE ALERTS " },
        ]}
      />
    </Box>
  );
};
